var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"m-icon-color",attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16.172 12.9999L4 12.9999L4 10.9999L16.172 10.9999L10.808 5.63592L12.222 4.22192L20\n  11.9999L12.222 19.7779L10.808 18.3639L16.172 12.9999Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }